import store from '@/store'

function getPaymentsList(bookingKey) {
  return new Promise((resolve, reject) => {
    store
      .dispatch('payments/apiCall', {
        mode: 'Select',
        request: {
          all: process.env.VUE_APP_API_ALL,
          srt: 'date',
          desc: false,
          bookingKey,
        },
      })
      .then(response => {
        if (response.success) {
          resolve(response.data.items)
        } else {
          reject(response.error)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

export default getPaymentsList
